import Box from "@mui/material/Box";
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import useUploadContext from "hooks/useUploadContext";
import "./index.scss";

const ColorButton = styled(Button)(() => ({
    width: '25%',
    height: '100%',
    boxSizing: 'border-box',
    padding: 0,
    margin: 0,
    backgroundColor: '#F3F3F3',
    boxShadow: 'inset 0 0 14px #000000',
    '&:hover': {
        backgroundColor: '#F3F3F3',
    },
    '.MuiSvgIcon-root': {
        fill: '#3D3D3D',
    }
}));

const ActionBox = () => {
    const { volume, tempo, bareBandiType, setManualCurrentTimeMusic, bares, setLayersUpdated, time, layersIsActive } = useUploadContext();
    const fixedValumeValue = (i) => `00${i}`.slice(-3);
    const fixedTemploValue = (i) => `00${Math.floor(Math.max(i, 0))}`.slice(-3);


    const handleAction = (i) => {
        let bareIndex = bares.findIndex(bare => bare >= time);
        let bare = bares.find(bare => bare === time);
        switch (i) {
            case 'next':
                if (time === bares[bares.length - 1] || bareIndex === bares.length - 1) {
                    bareIndex = bares.length - 1;
                } else if (bare !== undefined) {
                    bareIndex++
                }
                setManualCurrentTimeMusic(Math.min(bares[bareIndex], bares[bares.length - 1]));
                break
            case 'previous':
                if (time === bares[0]) {
                    return
                } else if (bare === undefined && bareIndex === 1) {
                    setManualCurrentTimeMusic(bares[0]);

                } else if (bare !== undefined) {
                    setManualCurrentTimeMusic(Math.max(bares[bareIndex - 1], 0));
                } else {
                    setManualCurrentTimeMusic(bares[bareIndex - 2]);
                }
                break
            case 'forward':
                if (bareIndex === bares.length - 1 && bare) return
                setManualCurrentTimeMusic(Math.min(time + 0.01, bares[bares.length - 1]));
                break
            case 'backward':
                if (bareIndex === 0 && bare) return
                setManualCurrentTimeMusic(Math.max(time - 0.01, 0));
                break
            default:
        }
        setLayersUpdated(true)
    };

    return (
        <Box className='actions-wrapper'>
            <Box className='volume-box'>
                {fixedValumeValue(volume)}
            </Box>
            <Box className='buttons-box'>
                <ColorButton disabled={!layersIsActive} onClick={() => handleAction('previous')}>
                    <SkipPreviousIcon />
                </ColorButton>
                <ColorButton disabled={!layersIsActive} onClick={() => handleAction('backward')}>
                    <FastRewindIcon />
                </ColorButton>
                <ColorButton disabled={!layersIsActive} onClick={() => handleAction('forward')}>
                    <FastForwardIcon />
                </ColorButton>
                <ColorButton disabled={!layersIsActive} onClick={() => handleAction('next')}>
                    <SkipNextIcon />
                </ColorButton>
            </Box>
            <Box className="tempo-box">
                <Box className={`tempo ${bareBandiType ? 'active' : ''}`}>{fixedTemploValue(tempo)}</Box>
            </Box>
        </Box>
    )
}

export default ActionBox;
